import React, { useState } from "react";
import Apikey from "../../../Component/ApiUser/apikey";
import Reportadmin from "../../../Component/ApiUser/admin/reportadmin";

const Home = () => {
  const [state, setstate] = useState({
    name: null,
    key: "",
    month: "",
    year: "",
    filter: false,
    loading: false,
  });

  const [loading, setloading] = useState(false);
  const [sum, setSum] = useState([]);

  return (
    <Apikey
      role="Administrator"
      state={state}
      choice={3}
      setstate={setstate}
      setSum={setSum}
      sum={sum}
      setloading={setloading}
    >
      <Reportadmin
        state={state}
        setloading={setloading}
        loading={loading}
        sum={sum}
      />
    </Apikey>
  );
};

export default Home;
